import _forEach from "lodash/forEach";
import _get from "lodash/get";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React from 'react';
import classnames from 'classnames';
import { Link } from "../../Button/Link/Link";
import { Countdown } from "../../Countdown/Countdown";
import { MARK_TAGS, renderMark } from "../RichTextLeaf/RichTextLeaf";
import { VideoPlayer } from "../../Video/VideoPlayer/VideoPlayer";
import { AnimationVideo } from "../../Video/AnimationVideo/AnimationVideo";
import Utility from "../../Utility/Utility";
export var RichTextElement = function RichTextElement(_ref) {
  var children = _ref.children,
    element = _ref.element,
    attributes = _ref.attributes;
  var tag = (element === null || element === void 0 ? void 0 : element.type) || '';
  if (element !== null && element !== void 0 && element.type) {
    switch (element.type) {
      case 'a':
        tag = Link;
        break;
      case 'countdown':
        tag = Countdown;
        break;
      case 'idMarker':
        tag = 'span';
        break;
    }
  }

  // Combine with Slate editor attributes
  var elementAttributes = Object.assign({}, attributes, element === null || element === void 0 ? void 0 : element.attributes);
  if ((element === null || element === void 0 ? void 0 : element.type) === 'a') {
    elementAttributes.url = _get(element, 'attributes.href');
  }
  if ((element === null || element === void 0 ? void 0 : element.type) === 'img') {
    // If img loading attribute has not been specified, set it to lazy
    if (!_get(element, 'attributes.loading')) {
      elementAttributes.loading = 'lazy';
    }
    // If WW image does not have auto param, add it with value webp
    var src = "".concat(elementAttributes.src) || '';
    if (src) {
      elementAttributes.src = Utility.getOptimizedCloudinaryUrl(src);
    }

    // Ensure an alt text is set, sanaitized if necessary.
    var altText = "".concat(elementAttributes.alt) || '';
    if (altText.trim() === '""' || altText === 'null' || altText === 'undefined') {
      altText = '';
    }
    altText = Utility.escapeHTML(altText);
    elementAttributes.alt = altText;
  }
  if (element !== null && element !== void 0 && element.typog) {
    var typogClass = "typog-".concat(element === null || element === void 0 ? void 0 : element.typog);
    elementAttributes.className = classnames(typogClass, elementAttributes.className);
  }
  if (element !== null && element !== void 0 && element.typog2) {
    var _typogClass = "typog2-".concat(element === null || element === void 0 ? void 0 : element.typog2);
    elementAttributes.className = classnames(_typogClass, elementAttributes.className);
  }

  // Inline videos do not have children.
  if ((element === null || element === void 0 ? void 0 : element.type) === 'brightcove') {
    return /*#__PURE__*/React.createElement(VideoPlayer, elementAttributes);
  }

  // Handle inline video elements
  if ((element === null || element === void 0 ? void 0 : element.type) === 'video' && elementAttributes.animation) {
    var videoProps = _objectSpread(_objectSpread({}, elementAttributes), {}, {
      sources: [{
        src: String(elementAttributes.src || ''),
        type: 'video/mp4'
      }]
    });
    return /*#__PURE__*/React.createElement(AnimationVideo, videoProps);
  }

  // An countdown tag uses the literal HTML, and wraps it in standard inline mark tags.
  // There are no children of an embed tag.
  if ((element === null || element === void 0 ? void 0 : element.type) === 'countdown') {
    if (element.color) {
      var colorClass = "typog--".concat(element.color);
      elementAttributes.className = classnames(colorClass, elementAttributes.className);
    }

    // Create countdown component with element attributes
    var countdownElement = /*#__PURE__*/React.createElement(tag, elementAttributes);
    // Loop through and wrap itself
    _forEach(MARK_TAGS, function (mark) {
      var renderedMark = renderMark(mark, element[mark], countdownElement);
      if (renderedMark) {
        countdownElement = renderedMark;
      }
    });

    // Create a span with processed MARKS wrapping.
    return /*#__PURE__*/React.createElement('span', null, countdownElement);
  }
  return /*#__PURE__*/React.createElement(tag, elementAttributes, children);
};